<div class="container">
  <div class="card my-4">
    <div class="card-body">
      <div [innerHTML]="aboutUsContent"></div>
    </div>
  </div>
</div>

